module.exports = "pegasus_template/assets/themecapture1/tickets/bg.png";